<template>
  <div>
    <b-spinner
      variant="primary"
      v-if="isSpinner"
      large
      class="pageLoadSpinners"
    />
    <div v-show="!isSpinner">
      <b-spinner
        variant="primary"
        v-if="isUpdating"
        large
        class="pageLoadSpinners"
        style="position: fixed"
      />
      <div class="faq_section">
        <app-collapse accordion v-for="faq in this.visibleCompanies" :key="faq.id">
          <app-collapse-item
            :title="`${faq.question}`"
            @click="$emit('visible')"
            >{{ faq.answer }}
            <p style="margin-top: 22px;margin-bottom: 4px;">
              <b-button variant="outline-danger delete" style="margin-right: 26px" @click="deletFunctionCalled(faq.id)" >Delete</b-button>
              <b-button variant="primary" style="margin-right: 26px" @click="editFunctionCalled(faq.question,faq.answer,faq.id)">Edit</b-button>
            </p>
          </app-collapse-item>
        </app-collapse>
        <div> 
        <b-button
        variant="outline-primary"
        class="d-inline-block align-top add_child_btn faq_btn cancelBookingClass12"
        id="toggle-btn"
        @click="faqVisible += step" v-if="faqVisible < faqs.length"
      >
        Load More
      </b-button>
        </div>
      </div>  
    </div>
  </div>
</template>

<script>
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import Ripple from "vue-ripple-directive";
import * as updateFirebase from "@/utils/FirebaseQueries/updateQueries/updateQueries.js";
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required } from '@validations';
import { mapGetters,mapActions,mapMutations } from "vuex";
import {
  VBModal,
  BModal,
  BButton,
  BSpinner
} from "bootstrap-vue";
import { dbCollections } from '@/utils/firebaseCollection';
export default {
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  components: {
    AppCollapse,
    AppCollapseItem,
    VBModal,
    BButton,
    BModal,
    ValidationProvider, ValidationObserver,
    BSpinner
  },
  data() {
    return {
      isSpinner: false,
      isUpdating: false,
      value: false,
      faqDynemicButton:'Update',
      faqPopupTitle:'Edit FAQ',
      faqVisible:20,
      step:20
    };
  },
  methods: {
    ...mapActions({
      'getFaqDatas': 'faqManagement/getFaqsData',
    }),
    ...mapMutations({
      'deleteFaqActionMutation' : "faqManagement/deleteFaq",
    }),
    
    editFunctionCalled(question,answer,id){
      this.$root.$emit("editFaqData",question,answer,id)      
    },
    deletFunctionCalled(id){
      let self = this;
      self.$bvModal
        .msgBoxConfirm("Are you sure you want to delete faq?", {
          title: "Delete",
          class: "test",
          okVariant: "primary",
          okTitle: "Yes",
          cancelTitle: "No",
          cancelVariant: "outline-primary",
          hideHeaderClose: false,
          centered: true,
          footerClass: "approve-footer",
          headerClass: "approve-header",
          bodyClass: "approve-body",
        })
        .then((value) => {
          if (value) {
            this.$root.$emit('startButtonDisabled')
            this.isSpinner = true;
            let Index = this.faqs.findIndex((values) => {
              return values.id == id;
            });
            this.deleteFaqActionMutation(Index)
            let updatedObject = {
              updatedAt: new Date(),
              isDeleted: true
            }
            updateFirebase.updateRootSubCollectionDataWithDocId(
              dbCollections.SETTINGS,"setting",
              dbCollections.FAQ,
              id,
              updatedObject,
              (res) => {
                self.$root.$emit('showToastMessage','Faq deleted successfully.','success');
                this.$root.$emit('stopButtonDisabled')
                this.isSpinner = false;
              }
            );
          }
        });
      
    }
  },
  created(){
    this.$root.$on('startFaqSpinner', () => {
      this.isSpinner = true;
    });
    this.$root.$on('stopFaqSpinner', () => {
      this.isSpinner = false;
    });
    this.$root.$on('faqUpdate', (editObject) => {
      let Indexss = this.faqs.findIndex((values) => {
        return values.id == editObject.id;
      });
      this.faqs[Indexss].answer = editObject.answer
      this.faqs[Indexss].question = editObject.question
    });
    this.isSpinner = true;
    let getFaqsFound = this.faqs.length != 0;
    if(!getFaqsFound){
      this.getFaqDatas().then(res=>{
        this.isSpinner = false;
      }).catch(error=>{
        console.error("error",error)
      })
    }else{
      this.isSpinner = false;
    }
  },
  watch:{
    faqVisible(val){
    }
  },
  computed: {
    ...mapGetters({
      faqs: "faqManagement/getFaq",
    }),
    visibleCompanies() {
      return this.faqs.slice(0, this.faqVisible)
    }
  },
};
</script>
<style scoped>
  .faq_btn {
    margin-top: 9px !important;
  }
  .cancelBookingClass12.btn-outline-primary:not(:disabled):not(.disabled):active,
.cancelBookingClass12.btn-outline-primary:not(:disabled):not(.disabled).active,
.cancelBookingClass12.btn-outline-primary:not(:disabled):not(.disabled):focus {
    background-color: transparent !important;
}
</style>